import { useMemo } from "react"
import { Brand, RateCardsConfig } from "../../../../../../types"

interface Props {
  info: RateCardsConfig
  brands: Brand[]
  onSelect: (id: string) => void
}

const NameCell = ({ info, brands, onSelect }: Props) => {
  const { id, brand_id, name, is_default } = info
  const brand = useMemo(
    () => brands.find(b => b.id === String(brand_id)),
    [brand_id, brands]
  )

  const handleClick = () => {
    onSelect(id)
  }

  return (
    <td
      className="whitespace-nowrap py-4 pl-2 pr-3 cursor-pointer hover:bg-gray-50"
      onClick={handleClick}
    >
      <div className="flex items-center">
        <div>
          <div className="font-medium text-gray-900">
            {name}
            {is_default === "1" && (
              <span className="ml-2 text-xs text-gray-500">(default)</span>
            )}
          </div>
          <div className="text-sm text-gray-500">
            {brand?.name ?? "Unknown brand"}
          </div>
        </div>
      </div>
    </td>
  )
}

export default NameCell
